export const isNullUndefinedOrEmpty = value => value === null || value === undefined || value === '';
//# sourceMappingURL=is_null_undefined_or_empty.js.map